import type { ReactNode, MouseEvent, TouchEvent } from 'react';
import { Button } from '@simplywallst/ui-core';
import { useTileSideToggle } from '../../TileSideToggleContext';

type Props = {
  children: ReactNode;
  onClick?: () => void;
};

export const SideToggleButton = ({ children, onClick }: Props) => {
  const { tileSide, toggleTileSide } = useTileSideToggle();

  const handleUserAction = (e: MouseEvent | TouchEvent) => {
    e.preventDefault();
    toggleTileSide(tileSide === 'front' ? 'back' : 'front');
    onClick?.();
  };

  return (
    <Button
      aria-label="More Information"
      onClick={(e) => {
        handleUserAction(e);
      }}
      onTouchEnd={(e) => {
        handleUserAction(e);
      }}
    >
      {children}
    </Button>
  );
};
